const API_BASE_URL = process.env.REACT_APP_API_BASE || 'https://api.shutterlocation.cn/api/vincent';

export const API_ENDPOINTS = {
  LOGIN: `${API_BASE_URL}/login`,
  CURRENT_ADMIN: `${API_BASE_URL}/current`,
  CHANGE_PASSWORD: `${API_BASE_URL}/password`,
  POSTS: `${API_BASE_URL}/posts`,
  POST_DETAIL: (id) => `${API_BASE_URL}/posts/${id}`,
  POST_DELETE: (id) => `${API_BASE_URL}/posts/${id}`,
  POST_STATUS: (id) => `${API_BASE_URL}/posts/${id}/status`,
  POST_BATCH_DELETE: `${API_BASE_URL}/posts/batch-delete`,
  USERS: `${API_BASE_URL}/users`,
  USER_DETAIL: (id) => `${API_BASE_URL}/users/${id}`,
  USER_BAN: (id) => `${API_BASE_URL}/users/${id}/ban`,
  USER_UNBAN: (id) => `${API_BASE_URL}/users/${id}/unban`,
  USER_DELETE: (id) => `${API_BASE_URL}/users/${id}`,
  REPORTS: `${API_BASE_URL}/reports`,
  REPORT_DETAIL: (id) => `${API_BASE_URL}/reports/${id}`,
  REPORT_HANDLE: (id) => `${API_BASE_URL}/reports/${id}/handle`,
  STATS_OVERVIEW: `${API_BASE_URL}/stats/overview`,
  STATS_USERS: `${API_BASE_URL}/stats/users`,
  STATS_POSTS: `${API_BASE_URL}/stats/posts`,
  STATS_TRENDS: `${API_BASE_URL}/stats/trends`,
  LOGS: `${API_BASE_URL}/logs`
};

export default API_BASE_URL;
